import { apiClient as axios, buildAuthRequestConfig } from './apiClient';
import { normalizeAttachmentList } from './attachmentNames';

// سيرفر الرفع بيغيّر اسم الملف (مثلاً 4232423.pdf)، فبنحفظ الاسم الأصلي اللي على جهاز المستخدم
// مع التذكرة / الرد / المشروع في attachmentNames = [{ url, name }].

const LARGE_UPLOAD_REQUEST_CONFIG = {
    maxBodyLength: Infinity,
    maxContentLength: Infinity,
    timeout: 0,
};

export const getUploadedLocations = (payload) => [
    payload?.location,
    payload?.data?.location,
    payload?.locations,
    payload?.data?.locations,
    payload?.files,
    payload?.data?.files,
]
    .flatMap((value) => Array.isArray(value) ? value : [value])
    .map((value) => typeof value === 'string' ? value : (value?.location || value?.url || value?.path || ''))
    .filter(Boolean);

export { buildAttachmentNameMap, getAttachmentInfo, normalizeAttachmentList, toAttachmentNamesPayload } from './attachmentNames';
// يرفع الملفات واحد واحد ويرجع [{ url, name }] بالاسم الأصلي لكل ملف.
export const uploadSupportFiles = async (fileList) => {
    const uploaded = [];
    for (const file of Array.from(fileList || [])) {
        const formData = new FormData();
        formData.append('myfile', file, file.name);
        const response = await axios.post(
            `${process.env.REACT_APP_UPLOADS_API_BASE_URL}/support`,
            formData,
            buildAuthRequestConfig(LARGE_UPLOAD_REQUEST_CONFIG)
        );
        getUploadedLocations(response.data).forEach((url) => uploaded.push({ url, name: file.name }));
    }
    return uploaded;
};

export const deleteUploadedFiles = async (urls) => {
    const list = normalizeAttachmentList(urls);
    if (!list.length) return true;
    const response = await axios.delete(
        `${process.env.REACT_APP_UPLOADS_API_BASE_URL}/delete`,
        buildAuthRequestConfig({ data: list.length > 1 ? { keyFiles: list } : { keyFile: list[0] }, validateStatus: () => true })
    );
    return response?.status >= 200 && response?.status < 300;
};

// التحميل باسم الملف الأصلي: خاصية download بتتجاهل الاسم لو الملف على دومين تاني، فبنحمّله blob الأول.
export const downloadAttachment = async (url, name) => {
    try {
        const response = await fetch(url);
        if (!response.ok) throw new Error('download failed');
        const blob = await response.blob();
        const objectUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = name || '';
        document.body.appendChild(link);
        link.click();
        link.remove();
        setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
    } catch {
        window.open(url, '_blank', 'noopener,noreferrer');
    }
};
